import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { stringStep } from '../../../concepts/commands/CommandWizard';
import { ToastType } from './ToastDefinition';
import { ToastHub } from './ToastHub';

export const toast = defineCommand(
    'toast',
    'Toas',
    (r, [message, type]: [string, ToastType?]) => {
        const hub = r.call(ToastHub);
        const def = {
            type: type || 'info',
            name: 'command',
            template: message,
        };
        hub.invoke(def, {});
    },
    [
        stringStep('message', 'Enter the message:'),
        stringStep('type', 'Enter the type (optional)', 'info'),
    ]
);

// export const sendAlert = defineCommand(
//     'sendAlert',
//     'Alert: Send',
//     (r, [message]: [string]) => {
//         const alerts = r.call(ToastHub);
//         alerts.sendAndInvoke({ body: message, delay: 5000 });
//     },
//     [
//         stringStep('Enter your message...')
//     ]
// );
